import { css } from '@emotion/css'
import { spacing } from '@offerzen/pinata'

const styles = {
  defaultMargin: css({
    marginBottom: spacing.large,
  }),

  largeMargin: css({
    marginBottom: spacing.extraLarge,
  }),

  radioInput: css({
    display: 'flex',
    alignItems: 'center',
    paddingBottom: spacing.default,

    '& > * + *': {
      marginLeft: spacing.default,
    },
  }),

  buttonWrapper: css({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: spacing.medium,
  }),
}

export default styles
